import type ProductDetailsType from '../../types/ProductDetailsType';

import styles from './ProductDescription.module.scss';

interface Props {
  product: ProductDetailsType;
}

const ProductDescription: React.FC<Props> = ({ product }) => {
  return (
    <div className={styles.productDescription}>
      <div className="container">
        <h3>więcej informacji:</h3>

        <div dangerouslySetInnerHTML={{ __html: product.description }} />
      </div>
    </div>
  );
};

export default ProductDescription;
